import { render } from "./offcanvas-body.vue?vue&type=template&id=b41ba2bc"
import script from "./offcanvas-body.vue?vue&type=script&lang=js"
export * from "./offcanvas-body.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__